import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 12 * 60 * 60 * 1000,
      // Deliberately short. Each cached period holds every raw row for its
      // range — T52W is ~310 MB of JSON, and more once parsed — so a user
      // clicking through T1W..YTD stacks all seven in the tab at once. Thirty
      // minutes kept them resident long past the point anyone would return to
      // them.
      //
      // Two, not ten, because the nearest failure is holding TWO periods at
      // once rather than one being too big. Measured in Chrome: heap grows
      // ~2.3 MB per 1,000 rows, so T52W at 800 sites is ~2,700 MB against a
      // 4,096 MB tab ceiling. One period fits; switching T52W -> YTD -> back
      // within the window keeps both and exceeds it. Over the ceiling the tab
      // dies outright -- there is no graceful degradation.
      //
      // Two minutes keeps the period on screen plus the one just left. The cost
      // is a refetch when someone returns after a pause, and the response is now
      // served from a gzipped file on disk in ~8 ms.
      gcTime: 2 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
